import { Flex, Link, LinkProps } from '@chakra-ui/react';
import React from 'react';

interface ILinkProps {
  linkStyles?: LinkProps;
  linkText: string;
  linkHref: string;
}

export const FooterLink = ({ linkStyles, linkText, linkHref }: ILinkProps) => {
  return (
    <Flex as="li">
      <Link
        href={linkHref}
        color="blackAlpha.400"
        textDecor="underline"
        isExternal
        aria-label={`${linkText} (opens in new window)`}
        {...linkStyles}
      >
        {linkText}
      </Link>
    </Flex>
  );
};
